import React from 'react';
import { Cross } from '@saleshandy/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { ImageIcon } from '@saleshandy/design-system';
import { DotsVerticals } from '../../../../../svg';
import { accessibleOnClick } from '../../../../../utils/accessible-on-click';
import { Images } from '../../../../../app-constants';

const DNDField = ({ field, handleOnToggle, fields }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: field.id });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  return (
    <div className="position-relative">
      <div
        className={`dnd-field ${isDragging ? 'isDragging' : ''}`}
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        style={style}
      >
        <div className="dnd-field-dragigng-conatiner">
          <div className="dnd-field--icon">
            <DotsVerticals />
          </div>

          <span>{field?.label || ''}</span>
          {fields?.find((f) => f?.id?.toString() === field?.id?.toString())
            ?.isAiGenerated && (
            <ImageIcon
              src={Images.NoResultGradient}
              alt="ai-icon"
              width={16}
              height={16}
              className="ai-sparkle-icon"
            />
          )}
        </div>
        {!field?.isNonRemovable && (
          <span
            className="dnd-field--remove"
            onPointerDown={(e) => e.stopPropagation()}
            {...accessibleOnClick(() => handleOnToggle(field))}
          >
            <Cross />
          </span>
        )}
      </div>
    </div>
  );
};

export default DNDField;
